/* Exporting patient available schedule dates,hors,closest default object. */
export default {
  avaliableDatesSchedule: [],
  avaliableTimesSchedule: [],
  avaliableClosestSchedule: [],
  updateTimeSchedule: false,
  updateDateTime: null,
};
